import { createGlobalStyle } from 'styled-components';
import { device } from './config/sizes';

import { appColors } from './config/colors';

import InterRegularWoff from './assets/fonts/inter-v3-latin-regular.woff';
import InterRegularWoff2 from './assets/fonts/inter-v3-latin-regular.woff2';
import InterBoldWoff from './assets/fonts/inter-v3-latin-700.woff';
import InterBoldWoff2 from './assets/fonts/inter-v3-latin-700.woff2';
import MerriweatherBoldWoff from './assets/fonts/merriweather-v30-latin-700.woff';
import MerriweatherBoldWoff2 from './assets/fonts/merriweather-v30-latin-700.woff2';

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    src: local(""),
      url(${InterRegularWoff2}) format("woff2"), 
      url(${InterRegularWoff}) format("woff"); 
  }

  @font-face {
    font-family: "Inter";
    font-style: normal;
    font-weight: 700;
    src: local(""),
      url(${InterBoldWoff2}) format("woff2"), 
      url(${InterBoldWoff}) format("woff"); 
  }

  @font-face {
    font-family: "Merriweather";
    font-style: normal;
    font-weight: 700;
    src: local(""),
      url(${MerriweatherBoldWoff2}) format("woff2"), 
      url(${MerriweatherBoldWoff}) format("woff"); 
  }

  html {
    box-sizing: border-box;
    font-size: 14px;

    @media ${device.legacy} { 
      font-size: 12px;
    }

    @media ${device.mobile} { 
      font-size: 14px;
    }

    @media ${device.tablet} { 
      font-size: 16px;
    }

    @media ${device.future} { 
      font-size: 18px;
    }
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  html,
  body {
    margin: 0;
    padding: 0;
  }

  body {
    font-family: "Inter", Helvetica, sans-serif;
    font-size: 1.2rem;
    line-height: 1.6;
    color: ${appColors.fontPrimary};
  }
  
  h1, h2, h3, h4, h5 {
    font-family: "Merriweather", Georgia, serif;
    font-weight: 700;
    line-height: 1.3;
    margin-bottom: 1em;
  }

  h1 {
    font-size: 1.75em;
    margin-top: 0;
  }
  
  h2 {
    font-size: 1.75em;
    margin-top: 5em;
  }

  h3, h4, h5 {
    font-size: 1em;
    margin-top: 3em;
  }
  
  p {
    margin: 1em 0 2em;
  }

  a {
    color: inherit;
  }


  ul {
    margin: 1em 0 2em;
    padding-left: 1em;
    list-style-type: square;
  }

  li {
    padding: 0;
    margin: 0 0.25em 0.5em 0;
  }

  video {
    position: relative;
    z-index: 1;
  }

  .noMargin {
    margin-top: 0;
    margin-bottom: 0;
  }

  .noMarginTop {
    margin-top: 0;
  }

  .smallMarginTop {
    margin-top: 1em;
  }

  .bigMarginTop {
    margin-top: 5em;
  }

  .noMarginBottom {
    margin-bottom: 0;
  }

  .smallMarginBottom {
    margin-bottom: 1em;
  }

  .bigMarginBottom {
    margin-bottom: 5em;
  }

  .greyText {
    color: ${appColors.fontSecondary};
  }
`;
